import React from 'react';

import {
  useReceiveTier1ReturnAuthorizationModalQuery,
  useReceiveTier1ReturnAuthorizationMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  expectedSerialNumber: string;
  itemId: string;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useReceiveTier1ReturnAuthorizationModalQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        expectedSerialNumber: tuple.data?.tier1ReturnAuthorization?.expectedSerialNumber ?? '',
        itemId: tuple.data?.tier1ReturnAuthorization?.item.id ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useReceiveTier1ReturnAuthorization(returnAuthorizationId: string) {
  const [fnMutate, tuple] = useReceiveTier1ReturnAuthorizationMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState, itemId: string) => {
      await fnMutate({
        variables: {
          input: {
            returnAuthorizationId,
            itemId,
            serialNumber: formState.serialNumber
          }
        }
      });
    },
    [
      fnMutate,
      returnAuthorizationId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
